var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatSendIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7793 3.21747C20.5727 3.01178 20.2655 2.94451 19.9918 3.04497L3.49183 9.04497C3.20048 9.15548 3.00781 9.43462 3.00781 9.74622C3.00781 10.0578 3.20048 10.337 3.49183 10.4475L10.6918 13.3275L13.5718 20.5275C13.6824 20.8055 13.9477 20.9912 14.2468 21C14.5571 20.9936 14.8314 20.7968 14.9368 20.505L20.9368 4.00497C21.0411 3.73411 20.9798 3.42738 20.7793 3.21747ZM14.2467 18.1499L12.1542 12.8999L15.7467 9.30738L14.6892 8.24988L11.0667 11.8724L5.84668 9.74988L18.9942 5.00238L14.2467 18.1499Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatSendIcon);
export default __webpack_public_path__ + "static/media/chat-send-icon.43394599794f08422dca37450d3106ef.svg";
export { ForwardRef as ReactComponent };